import type { PropsWithChildren } from 'react';

import { generateDataTestId } from '@/lib/tests';
import { useCommonModalProviderContext } from '@/providers/CommonModalProvider';

import * as S from './PriceInformation.styles';

interface PriceInformationProps extends PropsWithChildren {
  loading?: boolean;
}

export const PriceInformation = ({ loading }: PriceInformationProps) => {
  const { setPriceModalStatus } = useCommonModalProviderContext();
  return (
    <S.Wrapper $loading={!!loading} data-test-id='PriceInformationWrapper'>
      <S.Badge
        onClick={() => setPriceModalStatus(true)}
        {...generateDataTestId('priceInformation', 'badgeIcon')}
        data-test-id='PriceInformationBadge'
      />
    </S.Wrapper>
  );
};
